export default "__VITE_ASSET__$$NTIZR5__"